import { useDispatch } from 'react-redux'

import { SalesGroup } from '~shared-components/api/sales-groups'
import { useLoggedInUser } from '~shared-components/hooks/useLoggedInUser'
import { setSelectedSalesGroupAction } from '~shared-components/redux/actions/login.actions'
import { saveSelectedSalesGroupId } from '~shared-components/redux/localStorage'

import { useRedirectWithLocale } from './useRedirectWithLocale'

export const useSelectSalesGroup = () => {
  const { user } = useLoggedInUser()
  const dispatch = useDispatch()
  const { isLoading, redirect } = useRedirectWithLocale()

  const setSelectSalesGroup = async (selectedSalesGroup: SalesGroup) => {
    user!.currentSalesGroupId = selectedSalesGroup.id
    saveSelectedSalesGroupId(user!.email, selectedSalesGroup.id)
    dispatch(setSelectedSalesGroupAction(selectedSalesGroup))

    await redirect(selectedSalesGroup)
  }

  return { isLoadingGroup: isLoading, setSelectSalesGroup }
}
